'use client';

import { useCallback } from 'react';
import { useLegacyAuthEndpoint, useLocale, useRequestUrl } from '@ae/shared';

export const useLogin = () => {
  const locale = useLocale();
  const requestUrl = useRequestUrl();
  const legacyAuthEndpoint = useLegacyAuthEndpoint();

  const login = useCallback(() => {
    window.location.href = legacyAuthEndpoint(requestUrl, locale);
  }, [legacyAuthEndpoint, locale, requestUrl]);

  return { login };
};
